import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	languages: data.map((l: string) => ({ label: l, value: l })),
});
